import { useState } from 'react';
import { useAchievements, useUnlockedAchievements, useUpdateShowcase } from '../../api/hooks';
import { Medallion } from './Medallion';
import { haptics } from '../../telegram';
import { track } from '../../analytics';

/**
 * Редактор витрины (V1): bottom-sheet, до 3 закреплённых; закреплять можно
 * только полученные (уровень ≥ 1). Попытка добавить 4-е подсвечивает счётчик.
 */
export function ShowcaseEditorSheet({ onClose }: { onClose: () => void }) {
  const summary = useAchievements(null);
  const unlocked = useUnlockedAchievements(true);
  const save = useUpdateShowcase();
  const [selected, setSelected] = useState<number[]>(
    () => (summary.data?.showcase ?? []).map((s) => s.id),
  );
  const [overLimit, setOverLimit] = useState(false);

  const items = unlocked.data ?? [];
  const byId = new Map(items.map((i) => [i.id, i]));

  const toggle = (id: number) => {
    haptics.tap();
    setOverLimit(false);
    setSelected((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= 3) {
        setOverLimit(true);
        return prev;
      }
      return [...prev, id];
    });
  };

  const submit = async () => {
    try {
      await save.mutateAsync(selected);
      track('showcase_save', { count: selected.length });
      haptics.success();
      onClose();
    } catch {
      haptics.error();
    }
  };

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet ach-editor" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-handle" />
        <div className="ach-editor-head">
          <h3>Витрина</h3>
          <span className={`cnt${overLimit ? ' over' : ''}`}>{selected.length} из 3</span>
        </div>

        <div className="ach-editor-slots">
          {[0, 1, 2].map((i) => {
            const id = selected[i];
            const item = id === undefined ? undefined : byId.get(id);
            return item ? (
              <span key={id} className="slot">
                <Medallion icon={item.icon} level={item.level} maxLevel={item.maxLevel}
                  progress={null} state={item.state} size={52} glow />
                <button className="rm" onClick={() => toggle(item.id)} aria-label="Убрать">
                  ×
                </button>
              </span>
            ) : (
              <span key={`e-${i}`} className="slot slot--empty">
                +
              </span>
            );
          })}
        </div>

        <div className="ach-overline" style={{ margin: '14px 0 9px' }}>
          Полученные — тап, чтобы закрепить
        </div>
        {unlocked.isLoading ? (
          <div className="skeleton" style={{ height: 120, borderRadius: 12 }} />
        ) : items.length === 0 ? (
          <div className="ach-editor-empty">Пока нет достижений — сыграйте первый турнир</div>
        ) : (
          <div className="ach-editor-grid">
            {items.map((item) => {
              const on = selected.includes(item.id);
              return (
                <button key={item.id} className={`cell${on ? ' on' : ''}`} onClick={() => toggle(item.id)}>
                  <span className="wrap">
                    <Medallion icon={item.icon} level={item.level} maxLevel={item.maxLevel}
                      progress={null} state={item.state} size={46} ring={false} />
                    {on && <span className="check">✓</span>}
                  </span>
                  <span className="nm">{item.name}</span>
                </button>
              );
            })}
          </div>
        )}

        <button className="btn ach-editor-save" onClick={submit} disabled={save.isPending}>
          {save.isPending ? 'Сохранение…' : 'Сохранить витрину'}
        </button>
      </div>
    </div>
  );
}
